import React from 'react';
import { NavLink } from 'react-router-dom';
import {TagsAds} from './AdsComponent';

const Header = ({ hideTagsAds })  => {

  return (
    <header className="flex flex-wrap items-center justify-start">
      <div className="w-full flex items-center justify-left">
        <div className="flex items-center justify-left">
          <h2 className="text-4xl font-bold text-tw tracking-wide"> <NavLink 
                to={`/`} 
              >
               女神
              </NavLink></h2>
        </div>
      </div>
      {!hideTagsAds && <TagsAds />}
    </header>
  );
};

export default Header;
